import { SvgImage } from "components/SvgImage/SvgImage.component";
import { useTranslation } from "react-i18next";
import { createComponent } from "utils/libExtend/createComponent";

import { AppSwitchLang } from "../../../App/AppSwitchLang.component";
import { SHeader } from "./HeaderStyled/SHeader.styled";
import { SHeaderLogo } from "./HeaderStyled/SHeaderLogo.styled";
import { Menu } from "./Menu/Menu.component";

export const Header = createComponent("Header", () => {
  const { i18n } = useTranslation();
  const isFinOn = process.env.REACT_APP_FIN === "fin";
  return (
    <SHeader isArabic={i18n.language === "ar"}>
      <SHeaderLogo isFinOn={isFinOn} isArabic={i18n.language === "ar"}>
        <SvgImage name={isFinOn ? "LogoFin" : "Logo"} />
      </SHeaderLogo>
      <AppSwitchLang />
      <Menu />
    </SHeader>
  );
});
